<template>
    <div style="width: 100%; height: 100%;">
        <div class="custom-container">
            <v-row no-gutters justify="center">
                <v-col cols="12" md="8">
                    <v-card flat>
                        <v-card-title class="headline">
                            Nutzer erstellen
                        </v-card-title>
                        <v-form ref="detailsForm">
                            <v-card flat>
                                <v-card-title>
                                    Details
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            label="E-Mail-Adresse"
                                            outlined
                                            v-model="user.email"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Personalnummer"
                                            outlined
                                            v-model="user.staff_number"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Vorname"
                                            outlined
                                            v-model="user.first_name"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Nachname"
                                            outlined
                                            v-model="user.last_name"
                                    ></v-text-field>
                                    <v-autocomplete
                                            label="Vorgesetzte"
                                            v-model="user.supervisors"
                                            multiple
                                            :items="listSupervisors"
                                            outlined
                                            deletable-chips
                                            chips
                                    />
                                    <v-select
                                            label="Organisationseinheit"
                                            v-model="user.orga_unit_id"
                                            :items="orga_units"
                                            item-text="name"
                                            item-value="id"
                                            outlined/>
                                </v-card-text>
                            </v-card>
                            <v-card flat>
                                <v-card-title>
                                    Passwort
                                </v-card-title>
                                <v-card-text>
                                    <v-radio-group v-model="user.is_invited" row>
                                        <v-radio label="Einladung per E-Mail versenden" :value="true"/>
                                        <v-radio label="Passwort festlegen" :value="false"/>
                                    </v-radio-group>
                                    <div v-if="!user.is_invited">
                                        <v-text-field
                                                type="password"
                                                clearable
                                                label="Passwort"
                                                outlined
                                                v-model="user.password"
                                        ></v-text-field>
                                        <v-text-field
                                                type="password"
                                                clearable
                                                :error-messages="passwordMatchError"
                                                label="Passwort bestätigen"
                                                outlined
                                                v-model="user.password_confirmation"
                                        ></v-text-field>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-card flat>
                                <v-card-title>
                                    Rollen
                                </v-card-title>
                                <v-card-text>
                                    <v-select
                                            label="Rollen"
                                            multiple
                                            v-model="user.roles"
                                            :items="roles"
                                            outlined
                                            deletable-chips
                                            chips
                                    />
                                </v-card-text>
                            </v-card>
                        </v-form>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" md="auto">
                                    <v-btn color="error" outlined @click="cancel">Abbrechen</v-btn>
                                </v-col>
                                <v-col cols="12" md="auto">
                                    <v-btn color="success" depressed @click="postUser">Speichern</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

    export default {
        props: [],
        name: "",
        data: () => ({
            test: [],
            user: {
                is_invited: true,
                password: '',
                password_confirmation: '',
            },
            users: [],
            orga_units: [],
            roles: [],
        }),
        created() {
            this.getOrgaUnits();
            this.getRoles();
            this.getUsers();
        },
        computed: {
            passwordMatchError () {
                if (this.user.password && this.user.password_confirmation){
                    return (this.user.password === this.user.password_confirmation) ? '' : 'Die Passwörter müssen übereinstimmen.';
                }
                else{
                    return '';
                }
            },
            listSupervisors(){
                return this.users.map(item => {
                    let staff_number = item.staff_number ? '(' + item.staff_number + ')' : '';
                    return {
                        value: item.id,
                        text: item.last_name + ', ' + item.first_name + staff_number
                    };
                });
            },

        },
        methods: {
            cancel(){
                this.$router.push({name: 'SettingsUsers'})
            },
            postUser(){
                this.axios.post('/users', {
                    'user' : this.user,
                    'supervisors' : this.user.supervisors,
                    'roles' : this.user.roles,
                    'email' : this.user.email,
                }).then( (response) => {
                    this.$toast.success('Der Nutzer wurde erfolgreich angelegt!');
                    this.$router.push({ name: 'SettingsUsersEdit', params: { id: response.data }})
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                })
            },
            getOrgaUnits(){
                this.axios.get('/orga-units').then( (response) => {
                    this.orga_units = Object.values({...response.data.data});
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            },
            getRoles(){
                this.axios.get('/roles').then( (response) => {
                    this.roles = Object.values({...response.data});

                    this.roles = this.roles.map(item => {
                        var description;
                        if (item.name === 'employee'){
                            description = 'Mitarbeiter';
                        }
                        else if (item.name === 'supervisor'){
                            description = 'Vorgesetzter';
                        }
                        else if (item.name === 'hr-department'){
                            description = 'Personalabteilung';
                        }

                        else if (item.name === 'managing-board'){
                            description = 'Vorstand';
                        }

                        else if (item.name === 'system-admin'){
                            description = 'Systemadmin';
                        }

                        else if (item.name === 'ideasWorkbench'){
                          description = 'Werkbank';
                        }

                        else{
                            description = item.name;
                        }

                        return {
                            value: item.name,
                            text: description
                        }
                    });
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            },
            getUsers(){
                this.axios.get('/users').then( (response) => {
                    this.users = Object.values({...response.data.data.users});
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            }
        },
    }
</script>

<style scoped>

</style>
